<template>
  <v-container class="container1" v-if="affiliate" :class="getThemeColor">
    <v-row class="d-flex align-center" style="overflow:hidden;">
      <div class="d-flex align-center justify-center">
          <v-img
            :src="ip+affiliate.logo.url"
            data-aos="showupeffect" data-aos-duration="2000"
            contain
            max-height="105"
            max-width="200"
          >
          </v-img>
        <div class="kitchen-name-container" :class="getThemeColor">
          <div style="position:relative;overflow: hidden;">
            <div data-aos-anchor=".title-border" class="d-flex title-border border-white" data-aos="custom-fade" data-aos-duration="2000" style='min-width:100%;padding:1px;'></div>
            <div class="recipestitle2 font-size-l2" style="opacity: 0;cursor:default">{{$t('affiliate_recipe_page.title')}}</div>
            <div class="recipestitle2 font-size-l2" data-aos-easing="ease-out" data-aos="custom-title-fade-in" data-aos-duration="2000" data-aos-delay="1000">{{$t('affiliate_recipe_page.title')}}</div>
            <div data-aos-anchor=".title-border" class="d-flex title-border border-white" data-aos="custom-fade" data-aos-duration="2000" style='min-width:100%;padding:1px;'></div>
          </div>
        </div>
      </div>
    </v-row>
    <v-row data-aos="fade-up" data-aos-duration="3000">
      <v-col class="recipesblog" lg="3" md="3" v-for="(recipe, i) in affiliate.VideoRecipes" :key="i" @click="openDialog(recipe, i)">
        <div class="video-card">
          <v-img
            :src="ip+recipe.thumbnail.url"
            alt="John"
            height="73.2%"
            width="100%"
            class="video-card-image"
          >
            <span class="video-card-time">
              {{recipe.video_duration}}
            </span>
          </v-img>
          <div class="video-card-desc our-recipes-fontsize">
            <span class="dincond">{{recipe.name_row1[$i18n.locale]}}</span><br>
            <span class="dincond">{{recipe.name_row2[$i18n.locale]}}</span>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row class="d-flex ma-0 pa-1" :class="getThemeColor" style="margin-top:20px;position:relative;">
       <router-link :to="'/affiliate/'+affiliate_id" style="margin-left: auto;">
        <div class="button" style="float:left;margin-left: auto;"><span style="padding-right:10px" v-html="$t('affiliate_gallery_page.about_affiliate', { affiliate_name: affiliate.name[$i18n.locale] })"></span>
        <simple-line-icons
          icon="arrow-right"
          size="small"
          class="siis"
          no-svg
        /></div>
      </router-link>
      <div class="showfromtop" data-aos="showeffect" data-aos-duration="3000"></div>
    </v-row>
    <div v-if="dialog" class="custom-dialog" :class="dialog?'custom-dialog-show':''">
      <div class="overlay" @click.self.stop="dialog = false">
        <div class="main-dialog" :class="dialog?'ddd':''">
          <div style="position:absolute;top:0;bottom:0;left:0;right:0;background:white;opacity:0.9;"></div>
            <v-row class="ma-0 pa-3">
              <v-icon @click="dialog = false;" style="cursor:pointer;color:black;margin-left: auto;" size=36>mdi-close</v-icon>
            </v-row>
            <v-row class="pa-4 inner-dialog" v-if="dialog">
              <div style="z-index:0;width:100%;padding-top:56.25%;position:relative;" class="d-flex">
                <iframe style="position: absolute;top:0;bottom:0;left:0;right:0;" height="100%" width="100%" :src="'https://www.youtube.com/embed/'+currentRecipe.videoCode" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
              <div style="z-index:0; font-size:16px; padding-top:10px;cursor:default;">
                {{currentRecipe.name_row1[$i18n.locale]}}
              </div>
            </v-row>
            <v-row class="pa-4">
              <div class="overlay-button d-inline-flex align-center" style="float:left;z-index-0;" v-on:click="currentIndex==0?currentIndex=affiliate.VideoRecipes.length-1:currentIndex--;currentRecipe=affiliate.VideoRecipes[currentIndex]">
                <simple-line-icons
                  icon="arrow-left"
                  size="small"
                  color="black"
                  style="float:left;"
                  no-svg
                />
                <span style="padding-left:10px;" v-html="$t('affiliate_recipe_page.prev_video')"></span>
              </div>
            <div class="overlay-button d-inline-flex align-center " style="margin-left:auto;z-index-0;" v-on:click="currentIndex==affiliate.VideoRecipes.length-1?currentIndex=0:currentIndex++;currentRecipe=affiliate.VideoRecipes[currentIndex]">
              <span style="padding-right:10px;" v-html="$t('affiliate_recipe_page.next_video')"></span>
              <simple-line-icons
                icon="arrow-right"
                size="small"
                color="black"
                style="float:left;"
                no-svg
              />
            </div>
            </v-row>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment'
var ip = "https://lorencegroup.com/api";
export default {
  name: 'AffiiateRecipes',
  components: {
  },
  data: () => ({
    dialog: false,
    affiliate: null,
    currentRecipe: null,
    ip: ip,
    affiliate_id: null,
    currentIndex: 0
  }),
  methods: {
  openDialog(an, i){
    this.dialog = true;
    this.currentRecipe = an;
    this.currentIndex = i;
  },
  },
  mounted () {
    this.affiliate_id = this.$router.history.current.params.affiliate_id
    axios.get(ip+"/affiliates/"+this.$router.history.current.params.affiliate_id)
    .then(response => {
      this.affiliate=response.data;
      this.affiliate.name=[]
      this.affiliate.name["en"] = this.affiliate.display_name_english;
      this.affiliate.name["zh_TW"] = this.affiliate.display_name_trad_chinese;
      this.affiliate.EventPhotos.forEach(an => {
        an.event_date = moment(an.event_date, "YYYY-MM-DD").format("DD MMM YYYY");
        an.name_row1=[]
        an.name_row2=[]
        an.name_row1["en"] = an.display_row1_english;
        an.name_row2["en"] = an.display_row2_english;
        an.name_row1["zh_TW"] = an.display_row1_trad_chinese;
        an.name_row2["zh_TW"] = an.display_row2_trad_chinese;
      });
      this.currentRecipe=this.affiliate.VideoRecipes[0]
      console.log(this.affiliate)
    })
    .catch(e => {
      console.log(e)
      //this.errors.push(e)
    })
  },
  computed: {
    getThemeColor: function(){
      return {
        'black-theme': this.affiliate.theme=='black',
        'green-theme': this.affiliate.theme=='green'
      }
    },
  }
}
</script>

<style scoped>
.page-title{
  font-family: Georgia, 'Times New Roman', Times, serif;
  letter-spacing: 5px;
  color: white;
  padding: 10px;
  border-top: 1px white solid;
  border-bottom: 1px white solid;
  margin-left:50px;
}
.container1{
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 3%;
  padding-bottom: 2%;
}

.overlay-button{
  cursor: pointer;
  z-index: 0;
  background: white;
  font-size:14px;
  margin-top: 13px;
  padding: 5px 20px;
  color: #132b1b;
  border: #132b1b solid 1px;
  display: flex;
  width: fit-content;
  align-items:center;
}

.overlay-button:hover{
  background: mediumseagreen;
}

.custom-dialog{
  overflow-y: scroll;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
}
.custom-dialog-show{
  z-index: 1;
}
.custom-dialog .overlay{
  height: 100%;
  width: 100%;
}
.custom-dialog .main-dialog{
  position: relative;
  width: 70%;
  margin: auto;
}
.custom-dialog .main-dialog span{
  color: #132b1b;
}

.custom-dialog .main-dialog .special-text{
  color: mediumseagreen;
  z-index: 0;
}
@media (min-width: 768px) { 
  .custom-dialog .main-dialog{
    width: 100%;
    top: 50px;
    max-width: 800px;
  }


  .inner-dialog{
    max-width: 800px;
    margin: auto;
  }
}
@media (min-width: 992px) { 
  .custom-dialog .main-dialog{
    width: 80%;
    top: 50px;
    max-width: 900px;
  }

  .our-recipes-fontsize{
    font-size: 8px;
  }


  .inner-dialog{
    max-width: 800px;
    margin: auto;
  }
}
@media (min-width: 1264px) {
  .custom-dialog .main-dialog{
    width: 80%;
    top: 50px;
    max-width: 1100px;
  }

  .our-recipes-fontsize{
    font-size: 14px;
  }

  .inner-dialog{
    max-width: 800px;
    margin: auto;
  }
}
@media (min-width: 1904px) { 
  .custom-dialog .main-dialog{
    width: 70%;
    top: 50px;
    max-width: 1300px;
  }

  .our-recipes-fontsize{
    font-size: 16px;
  }

  .inner-dialog{
    max-width: 800px;
    margin: auto;
  }
}
.kitchen-name-container{
  font-family: 'dincond';
  float:left;
  display:flex;
  align-items:center;
  height:120px;
}
.recipestitle{ 
  padding: 15px;
}
.title-border{
  padding: 17px;
  transition: border 1s;
  border-top: 1px white solid;
  border-bottom: 1px white solid;
}
.kitchen-logo{
  margin: 20px;
  float: left;
}
.kitchen-photo{
  width: 70%;
  margin: auto;
}
.recipestitle2{
  margin: auto;
  color: white;
  padding: 15px;
  border-top: 1px white solid;
  border-bottom: 1px white solid;
  margin-top:90px;
  margin-bottom:50px;
}

.videoblog{
  margin-top:20px;
}

.recipesblog{
  margin-top:20px;
}
.video-card{
  cursor: pointer;
  position: relative;
  padding-top:80.3%;
}

.video-card-image{
  position: absolute;
  top:0;
  left:0;
}
.video-card-desc{
  font-family: 'dincond';
  letter-spacing: 2px;
  position: absolute;
  padding: 1px;
  padding-left: 10px;
  text-align: left;
  top:77.2%;
  left:0;
  height: 25%;
  width: 100%;
  color: white;
  border-left: 1px solid green;
  border-bottom: 1px solid green;
}
.video-card-image:hover + .video-card-desc{
  color: green;
}
.video-card div:hover + .video-card-desc{
  color: green;
}
.video-card-desc:hover{
  color: green;
}
.video-card-time{
  background: black;
  color: white;
  opacity: .7;
  position: absolute;
  top: 86%;
  left: 88%;
}
.pageination{
  color: white;
  margin: 10px;
}
.selected{
  text-decoration: underline;
}
.customizefont1{
  font-family: Georgia, 'Times New Roman', Times, serif;
  letter-spacing: 5px;
  color: white;
  font-size: 30px;
}

.MHeiHK{
  font-family: 'MHeiHK';
}

.slide-container{
  padding-top: 66.4%;
  position: relative;
}
.button{
  margin: auto;
  color: green;
  border: green solid 1px;
  display: flex;
  width: fit-content;
  align-items:center;
  cursor: pointer; 
  transform: scale(1, .8);

}

.button:hover{
  color:white;
  background: mediumseagreen;
  border: mediumseagreen solid 1px;
}
</style>